import {
  ThemeIcon,
  UnstyledButton,
  type UnstyledButtonProps,
  type ElementProps,
} from '@mantine/core';
import {
  IconChevronDown,
  IconFilter,
  IconFilterOff,
} from '@tabler/icons-react';
import classes from './toggleFilterButton.module.scss';

interface ToggleFiltersButtonProps
  extends
    UnstyledButtonProps,
    ElementProps<'button', keyof UnstyledButtonProps> {
  isOpened?: boolean;
}

export const ToggleFilterButton = ({
  isOpened = false,
  children,
  ...props
}: ToggleFiltersButtonProps) => {
  return (
    <UnstyledButton
      {...props}
      mod={{ opened: isOpened }}
      className={classes.root}
    >
      {isOpened ? (
        <IconFilterOff color='var(--mantine-color-secondary-9)' />
      ) : (
        <IconFilter color='var(--mantine-color-secondary-9)' />
      )}

      {children}
      <ThemeIcon variant='transparent' size={24} className={classes.chevron}>
        <IconChevronDown />
      </ThemeIcon>
    </UnstyledButton>
  );
};
